import React from 'react'
import {PDivider, PWordmark} from "@porsche-design-system/components-react";

function AppHeader() {
	return (
		<div className={"app-header"}>
			<PWordmark className={"app-logo"}  autoFocus={false} inert size="small" />
			<PDivider className={"divider"}  autoFocus={false} inert />
		</div>
	);
}
export default AppHeader;